module.exports = __webpack_public_path__ + "img/Group2.7592147e.svg";